import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  resolveHubForLegacySubTab,
  DOCUMENT_HUBS,
} from '@/pages/documents/shared/tab-resolver';

// Redirect compat per i deeplink legacy `/documents` e `/documents?subTab=*`
// senza id (lista). Mappiamo il subTab legacy al nuovo hub; senza subTab
// atterriamo su `/invoices` come default coerente con la sidebar.
export const Route = createFileRoute('/protected/_layout/documents/_layout/')({
  beforeLoad: ({ search }) => {
    const targetHub =
      resolveHubForLegacySubTab(search.subTab ?? undefined) ??
      DOCUMENT_HUBS.invoices;
    // TanStack Router non sa che `search` e' un superset dei param
    // accettati dall'hub target: e' valido a runtime, lo passa as-is.
    throw redirect({ to: targetHub.basePath, search } as never);
  },
  component: () => null,
});
